// import {
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
// } from "@react-google-maps/api";
// import { Button } from "primereact/button";
// import { Dropdown } from "primereact/dropdown";
// import { InputText } from "primereact/inputtext";
// import { useCallback, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import useHeroAPI from "../../api/useHeroAPI";
// import usePreDefinedListAPI from "../../api/usePreDefinedListAPI";
// import { setLoading } from "../../redux/loadingSlice";

// import "./StoreLocator.css";
// // import debounce from "../../utils/debounce";
// const libraries: "places"[] = ["places"];
// const debounce = (func: any, wait: any) => {
//   let timeout: any;
//   return function executedFunction(...args: any) {
//     const later = () => {
//       clearTimeout(timeout);
//       func(...args);
//     };
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// };
// const StoreLocator = () => {
//   const defaultCity = "Mumbai";

//   const loading = useSelector((state: any) => state.loading);
//   const dispatch = useDispatch();

//   const containerStyle = {
//     width: "100%",
//     height: "94vmin",
//   };

//   const center = {
//     lat: 19.1860219,
//     lng: 72.8563181,
//   };
//   const { getSPList } = usePreDefinedListAPI();
//   const { predefinedFunc } = useHeroAPI();

//   const [selected, setSelected] = useState(null) as any;
//   const [searchInput, setSearchInput] = useState("") as any;
//   const [servicePointsData, setServicePointsData] = useState([]) as any;
//   const [selectedCity, setSelectedCity] = useState(null) as any;
//   const [cityOptions, setCityOptions] = useState([]) as any;
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const [locationChecked, setLocationChecked] = useState(false);
//   // const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(true);
//   const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(
//     window.innerWidth >= 760,
//   );
//   const [mapCenter, setMapCenter] = useState(center);
//   const [mapZoom, setMapZoom] = useState(5);

//   // const getUserLocation = (cities: any[]) => {
//   //   if (!navigator.geolocation) return;

//   //   navigator.geolocation.getCurrentPosition(
//   //     (position) => {
//   //       const { latitude, longitude } = position.coords;

//   //       const geocoder = new window.google.maps.Geocoder();

//   //       geocoder.geocode(
//   //         {
//   //           location: {
//   //             lat: latitude,
//   //             lng: longitude,
//   //           },
//   //         },
//   //         (results: any, status: any) => {
//   //           if (status === "OK" && results?.length) {
//   //             const cityComponent = results[0].address_components.find(
//   //               (component: any) => component.types.includes("locality"),
//   //             );

//   //             if (cityComponent) {
//   //               const cityName = cityComponent.long_name;

//   //               // const matchedCity = cities.find(
//   //               //   (city: any) =>
//   //               //     city.name.toLowerCase() === cityName.toLowerCase(),
//   //               // );
//   //               const matchedCity = cities.find(
//   //                 (city: any) =>
//   //                   city.name.trim().toLowerCase() ===
//   //                   cityName.trim().toLowerCase(),
//   //               );

//   //               if (matchedCity) {
//   //                 setSelectedCity(matchedCity);
//   //               }
//   //             }
//   //           }
//   //         },
//   //       );
//   //     },
//   //     (error) => {
//   //       console.log("Location permission denied", error);
//   //     },
//   //   );
//   // };
//   const getUserLocation = (cities: any[]) => {
//     if (!navigator.geolocation) {
//       setLocationChecked(true);
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const { latitude, longitude } = position.coords;

//         const geocoder = new window.google.maps.Geocoder();

//         geocoder.geocode(
//           {
//             location: {
//               lat: latitude,
//               lng: longitude,
//             },
//           },
//           (results: any, status: any) => {
//             if (status === "OK" && results?.length) {
//               const cityComponent = results[0].address_components.find(
//                 (component: any) => component.types.includes("locality"),
//               );

//               if (cityComponent) {
//                 const cityName = cityComponent.long_name;
//                 const matchedCity = cities.find(
//                   (city: any) =>
//                     city.name.trim().toLowerCase() ===
//                     cityName.trim().toLowerCase(),
//                 );

//                 if (matchedCity) {
//                   setSelectedCity(matchedCity);
//                 } else {
//                 }

//                 setLocationChecked(true);
//               }
//             }

//             setLocationChecked(true);
//           },
//         );
//       },
//       () => {
//         setLocationChecked(true);
//       },
//     );
//   };
//   const fetchPredefinedOptions = async () => {
//     const cityPredefinedPayload = {
//       entity_type: "CITY",
//     };

//     const cityPredefinedResponse: any = await predefinedFunc(
//       cityPredefinedPayload,
//     );
//     const cities = cityPredefinedResponse?.data?.data || [];

//     setCityOptions(cities);
//   };

//   const customMarkerIcon = {
//     url: "https://mechmiles.com/location-pin.png",
//     scaledSize: { width: 50, height: 50 } as google.maps.Size,
//   };

//   const fetchServicePoints = async (searchValue?: any) => {
//     let city_id = selectedCity?.predefined_id || null;

//     const payload = {
//       city_id: selectedCity?.predefined_id || null,
//       search_by: selectedCity ? (searchValue ?? searchInput) : "",
//     };

//     const response: any = await getSPList(payload);
//     if (response.status === 200) {
//       dispatch(setLoading(false));
//       const mappedServicePointList = response?.data?.map(
//         (servicePoint: any) => {
//           return {
//             id: servicePoint?.service_point_id,
//             name: servicePoint?.service_point_name,
//             location:
//               servicePoint?.lat && servicePoint?.lng
//                 ? {
//                     lat: parseFloat(servicePoint.lat),
//                     lng: parseFloat(servicePoint.lng),
//                   }
//                 : null,
//             subTitle: servicePoint?.description,
//             address: servicePoint?.service_point_address,
//             phone: servicePoint?.service_point_contact,
//           };
//         },
//       );
//       setServicePointsData(mappedServicePointList);
//     }
//   };
//   const fetchServicePointsDebounced = useCallback(
//     debounce((searchValue: any) => {
//       fetchServicePoints(searchValue);
//     }, 500),
//     [selectedCity],
//   );
//   useEffect(() => {
//     if (!locationChecked) return;

//     if (searchInput.trim()) {
//       fetchServicePointsDebounced(searchInput);
//     }
//   }, [searchInput, fetchServicePointsDebounced, locationChecked]);
//   useEffect(() => {
//     if (!locationChecked) return;

//     dispatch(setLoading(true));

//     if (!selectedCity) {
//       setSelected(null);
//       setSearchInput("");
//     }

//     fetchServicePoints();
//   }, [selectedCity, locationChecked]);

//   useEffect(() => {
//     fetchPredefinedOptions();
//   }, []);
//   useEffect(() => {
//     if (mapLoaded && cityOptions.length > 0) {
//       getUserLocation(cityOptions);
//     }
//   }, [mapLoaded, cityOptions]);

//   const handleSearchInput = (e: any) => {
//     // setSelected(null);
//     // setSelectedCity(null);
//     // setServicePointsData([]);
//     setSearchInput(e.target.value);
//   };
//   const handleServicePointSelection = (servicePoint: any) => {
//     setSelected(servicePoint);
//     setSearchInput(servicePoint.name);

//     if (servicePoint.location) {
//       setMapCenter(servicePoint.location);
//       setMapZoom(15);
//     }

//     if (window.innerWidth < 760) {
//       setIsSearchPanelOpen(false);
//     }
//   };
//   // const handleServicePointSelection = (servicePoint: any) => {
//   //   setSelected(servicePoint);
//   //   setSearchInput(servicePoint.name);

//   //   if (window.innerWidth < 760) {
//   //     setIsSearchPanelOpen(false);
//   //   }
//   // };

//   const getDirectionFunc = (lat: any, lng: any) => {
//     const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
//     const link = document.createElement("a");
//     link.href = url;
//     link.target = "_blank";
//     link.rel = "noopener noreferrer";
//     document.body.appendChild(link);
//     link.click();

//     // Clean up the DOM
//     document.body.removeChild(link);
//   };
//   const handleCityChange = (e: any) => {
//     const city = e.value;

//     setSelectedCity(city);

//     if (city?.lat && city?.lng) {
//       setMapCenter({
//         lat: parseFloat(city.lat),
//         lng: parseFloat(city.lng),
//       });
//       setMapZoom(11);
//     }
//   };
//   // const handleCityChange = (e: any) => {
//   //   const city = e.value;

//   //   setSelectedCity(city);

//   //   if (!city) {
//   //     setSelected(null);
//   //     setSearchInput("");

//   //     if (window.innerWidth >= 760) {
//   //       setIsSearchPanelOpen(true);
//   //     }
//   //   }
//   // };
//   // useEffect(() => {
//   //   const handleResize = () => {
//   //     if (window.innerWidth <= 768) {
//   //       setIsSearchPanelOpen(false);
//   //     } else {
//   //       setIsSearchPanelOpen(true);
//   //     }
//   //   };

//   //   handleResize(); // run on first load

//   //   window.addEventListener("resize", handleResize);

//   //   return () => {
//   //     window.removeEventListener("resize", handleResize);
//   //   };
//   // }, []);
//   // if (!locationChecked) {
//   //   return <div className="loading-overlay">Detecting your location...</div>;
//   // }
//   // if (!locationChecked) {
//   //   return <div className="loading-overlay">Detecting your location...</div>;
//   // }
//   useEffect(() => {
//     const handleResize = () => {
//       setIsSearchPanelOpen(window.innerWidth >= 760);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <div className="map-wrapper">
//       {loading && <div className="loading-overlay">Loading...</div>}
//       <LoadScript
//         googleMapsApiKey="AIzaSyBc8f4IQtJeK5lr0iEhUy0KbFQCe4JCPnQ"
//         libraries={libraries}
//         onLoad={() => {
//           setMapLoaded(true);
//         }}
//       >
//         <div className="container-fluid p-0">
//           {/* {isSearchPanelOpen && (
//             <div className="location-search-panel"> */}
//           <div className="map-container">
//             {!isSearchPanelOpen && window.innerWidth < 760 && (
//               <div
//                 className="reopen-search-panel"
//                 onClick={() => setIsSearchPanelOpen(true)}
//               >
//                 🔍
//               </div>
//             )}
//             {isSearchPanelOpen && mapLoaded && (
//               <div
//                 className="location-search-panel11"
//                 style={{
//                   background: "#fff",
//                   padding: "1.25rem",
//                   maxWidth: "400px",
//                   position: "absolute",
//                   top: "120px",
//                   left: "10px",
//                   // right: "65px",
//                   boxShadow: "0 8px 20px 0 rgba(0, 0, 0, 0.12)",
//                   zIndex: 1,
//                   maxHeight: "450px",
//                   overflowY: "scroll",
//                   paddingTop: 0,
//                 }}
//               >
//                 <div className="location-select-city">
//                   <div className="field col-12 ">
//                     <label htmlFor="city">Enter Your City Name</label>
//                     <Dropdown
//                       className="w-full"
//                       value={selectedCity}
//                       options={cityOptions}
//                       onChange={handleCityChange}
//                       placeholder="Select a City"
//                       // optionValue="predefined_id"
//                       optionLabel="name"
//                       showClear
//                       filter
//                       virtualScrollerOptions={{ itemSize: 38 }}
//                     />
//                   </div>
//                   <div className="field col-12">
//                     <label htmlFor="city">Search Service Points</label>
//                     <InputText
//                       placeholder="Search Service Points"
//                       className="col-12"
//                       value={searchInput}
//                       onChange={handleSearchInput}
//                     />
//                   </div>
//                 </div>
//                 {!servicePointsData?.length && (
//                   <div className="empty-service-point-list">
//                     No Service Points Found
//                   </div>
//                 )}
//                 {servicePointsData?.map((point: any) => (
//                   // <div key={point.id} className="location-sp-option-wrapper" style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div
//                     key={point.id}
//                     className="location-sp-option-wrapper"
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       gap: "30px",
//                       alignItems: "center",
//                       borderTop: "1px solid #e3e3e3",
//                       padding: "0.9375rem 0 0.3125rem",
//                     }}
//                   >
//                     <div className="location-sp-name-wrapper">
//                       <div className="location-sp-name">{point.name}</div>
//                       <div className="location-sp-address">{point.address}</div>
//                     </div>

//                     <div className="location-sp-locate-btn">
//                       {/* <Button onClick={() => handleServicePointSelection(point)}>
//                       Select
//                     </Button> */}
//                       <Button
//                         type="button"
//                         disabled={!point.location}
//                         onClick={(e) => {
//                           e.preventDefault();
//                           e.stopPropagation();
//                           handleServicePointSelection(point);
//                         }}
//                       >
//                         Select
//                       </Button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//             <GoogleMap
//               mapContainerStyle={containerStyle}
//               center={mapCenter}
//               zoom={mapZoom}
//             >
//               {/* <GoogleMap
//               mapContainerStyle={containerStyle}
//               center={selected?.location || center}
//               zoom={selected?.location ? 15 : 5}
//             > */}
//               {/* <MarkerClusterer>
//                                 {(clusterer) => */}
//               {/* {servicePointsData?.map((point: any) => (
//                 <Marker
//                   key={point.id}
//                   position={point.location}
//                   onClick={() => setSelected(point)}
//                   icon={customMarkerIcon}
//                   // clusterer={clusterer}
//                 />
//               ))} */}
//               {servicePointsData
//                 ?.filter((point: any) => point.location)
//                 ?.map((point: any) => (
//                   <Marker
//                     key={point.id}
//                     position={point.location}
//                     onClick={() => setSelected(point)}
//                     icon={customMarkerIcon}
//                   />
//                 ))}
//               {/* }
//                             </MarkerClusterer> */}
//               {selected?.location && (
//                 <div className="map-pin-wrapper">
//                   <InfoWindow
//                     position={selected.location}
//                     onCloseClick={() => setSelected(null)}
//                   >
//                     <div className="map-location-tooltip">
//                       <div className="selected-service-point-name">
//                         {selected?.name}
//                       </div>
//                       <div className="selected-service-point-address">
//                         {selected?.address ?? "Address Not Available"}
//                       </div>
//                       {/* <div className='selected-service-point-phone'><FaPhone /> {selected?.phone ?? 'Phone Not Available'}</div> */}
//                       <div className="selected-service-point-goto-location-wrapper">
//                         <div
//                           className="selected-service-point-goto-location"
//                           onClick={() =>
//                             getDirectionFunc(
//                               selected?.location.lat,
//                               selected?.location.lng,
//                             )
//                           }
//                         >
//                           Go To Location
//                         </div>
//                       </div>
//                     </div>
//                   </InfoWindow>
//                 </div>
//               )}
//             </GoogleMap>
//           </div>
//         </div>
//       </LoadScript>
//     </div>
//   );
// };

// export default StoreLocator;
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useHeroAPI from "../../api/useHeroAPI";
import usePreDefinedListAPI from "../../api/usePreDefinedListAPI";
import { setLoading } from "../../redux/loadingSlice";

import "./StoreLocator.css";

const libraries: "places"[] = ["places"];
const debounce = (func: any, wait: any) => {
  let timeout: any;
  return function executedFunction(...args: any) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const StoreLocator = () => {
  const defaultCity = "Mumbai";
  const loading = useSelector((state: any) => state.loading);
  const dispatch = useDispatch();

  const containerStyle = { width: "100%", height: "94vmin" };
  const center = { lat: 19.1860219, lng: 72.8563181 };

  const { getSPList } = usePreDefinedListAPI();
  const { predefinedFunc } = useHeroAPI();

  const [selected, setSelected] = useState(null) as any;
  const [searchInput, setSearchInput] = useState("") as any;
  const [servicePointsData, setServicePointsData] = useState([]) as any;
  const [selectedCity, setSelectedCity] = useState(null) as any;
  const [cityOptions, setCityOptions] = useState([]) as any;
  const [mapLoaded, setMapLoaded] = useState(false);
  const [locationChecked, setLocationChecked] = useState(false);
  const [appReady, setAppReady] = useState(false);
  const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(
    window.innerWidth >= 760,
  );
  const [mapCenter, setMapCenter] = useState(center);
  const [mapZoom, setMapZoom] = useState(5);

  const getUserLocation = (cities: any[]) => {
    if (!navigator.geolocation) {
      setLocationChecked(true);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat: latitude, lng: longitude } },
          (results: any, status: any) => {
            if (status === "OK" && results?.length) {
              const cityComponent = results[0].address_components.find(
                (c: any) => c.types.includes("locality"),
              );
              if (cityComponent) {
                const matchedCity = cities.find(
                  (city: any) =>
                    city.name.trim().toLowerCase() ===
                    cityComponent.long_name.trim().toLowerCase(),
                );
                if (matchedCity) setSelectedCity(matchedCity);
              }
            }
            setLocationChecked(true);
          },
        );
      },
      () => setLocationChecked(true),
    );
  };

  const fetchPredefinedOptions = async () => {
    const cityPredefinedResponse: any = await predefinedFunc({
      entity_type: "CITY",
    });
    const cities = cityPredefinedResponse?.data?.data || [];
    setCityOptions(cities);
  };

  const customMarkerIcon = {
    url: "https://mechmiles.com/location-pin.png",
    scaledSize: { width: 50, height: 50 } as google.maps.Size,
  };

  const fetchServicePoints = async (searchValue?: any) => {
    const payload = {
      city_id: selectedCity?.predefined_id || null,
      search_by: selectedCity ? (searchValue ?? searchInput) : "",
    };
    const response: any = await getSPList(payload);
    if (response.status === 200) {
      dispatch(setLoading(false));
      setAppReady(true);
      const mappedServicePointList = response?.data?.map(
        (servicePoint: any) => ({
          id: servicePoint?.service_point_id,
          name: servicePoint?.service_point_name,
          location:
            servicePoint?.lat && servicePoint?.lng
              ? {
                  lat: parseFloat(servicePoint.lat),
                  lng: parseFloat(servicePoint.lng),
                }
              : null,
          subTitle: servicePoint?.description,
          address: servicePoint?.service_point_address,
          phone: servicePoint?.service_point_contact,
        }),
      );
      setServicePointsData(mappedServicePointList);
    }
  };

  const fetchServicePointsDebounced = useCallback(
    debounce((searchValue: any) => fetchServicePoints(searchValue), 500),
    [selectedCity],
  );

  useEffect(() => {
    if (!locationChecked) return;
    if (searchInput.trim()) fetchServicePointsDebounced(searchInput);
  }, [searchInput, fetchServicePointsDebounced, locationChecked]);

  useEffect(() => {
    if (!locationChecked) return;
    dispatch(setLoading(true));
    if (!selectedCity) {
      setSelected(null);
      setSearchInput("");
    }
    fetchServicePoints();
  }, [selectedCity, locationChecked]);

  useEffect(() => {
    fetchPredefinedOptions();
  }, []);

  useEffect(() => {
    if (mapLoaded && cityOptions.length > 0) getUserLocation(cityOptions);
  }, [mapLoaded, cityOptions]);

  const handleSearchInput = (e: any) => setSearchInput(e.target.value);

  const handleServicePointSelection = (servicePoint: any) => {
    setSelected(servicePoint);
    setSearchInput(servicePoint.name);
    if (servicePoint.location) {
      setMapCenter(servicePoint.location);
      setMapZoom(15);
    }
    if (window.innerWidth < 760) setIsSearchPanelOpen(false);
  };

  const getDirectionFunc = (lat: any, lng: any) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCityChange = (e: any) => {
    const city = e.value;
    setSelectedCity(city);
    if (city?.lat && city?.lng) {
      setMapCenter({ lat: parseFloat(city.lat), lng: parseFloat(city.lng) });
      setMapZoom(11);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsSearchPanelOpen(window.innerWidth >= 760);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="map-wrapper">
      {/* ── Loader overlay: shows until map is loaded ── */}
      {/* {!mapLoaded && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0, 0, 0, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader" />
        </div>
      )} */}
      {/* ── Redux-driven loading overlay (data fetches) ── */}
      {/* {loading && mapLoaded && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 9998,
            background: "rgba(0, 0, 0, 0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader" />
        </div>
      )} */}

      {!appReady && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0, 0, 0, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader" />
        </div>
      )}
      <LoadScript
        googleMapsApiKey="AIzaSyBc8f4IQtJeK5lr0iEhUy0KbFQCe4JCPnQ"
        libraries={libraries}
        onLoad={() => setMapLoaded(true)}
      >
        <div className="container-fluid p-0">
          <div className="map-container">
            {!isSearchPanelOpen && window.innerWidth < 760 && (
              <div
                className="reopen-search-panel"
                onClick={() => setIsSearchPanelOpen(true)}
              >
                🔍
              </div>
            )}

            {isSearchPanelOpen && mapLoaded && (
              <div
                className="location-search-panel11"
                style={{
                  background: "#fff",
                  padding: "1.25rem",
                  maxWidth: "400px",
                  position: "absolute",
                  top: "120px",
                  left: "10px",
                  boxShadow: "0 8px 20px 0 rgba(0,0,0,0.12)",
                  zIndex: 1,
                  maxHeight: "450px",
                  overflowY: "scroll",
                  paddingTop: 0,
                }}
              >
                <div className="location-select-city">
                  <div className="field col-12">
                    <label htmlFor="city">Enter Your City Name</label>
                    <Dropdown
                      className="w-full"
                      value={selectedCity}
                      options={cityOptions}
                      onChange={handleCityChange}
                      placeholder="Select a City"
                      optionLabel="name"
                      showClear
                      filter
                      virtualScrollerOptions={{ itemSize: 38 }}
                    />
                  </div>
                  <div className="field col-12">
                    <label htmlFor="city">Search Service Points</label>
                    <InputText
                      placeholder="Search Service Points"
                      className="col-12"
                      value={searchInput}
                      onChange={handleSearchInput}
                    />
                  </div>
                </div>

                {!servicePointsData?.length && (
                  <div className="empty-service-point-list">
                    No Service Points Found
                  </div>
                )}

                {servicePointsData?.map((point: any) => (
                  <div
                    key={point.id}
                    className="location-sp-option-wrapper"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "30px",
                      alignItems: "center",
                      borderTop: "1px solid #e3e3e3",
                      padding: "0.9375rem 0 0.3125rem",
                    }}
                  >
                    <div className="location-sp-name-wrapper">
                      <div className="location-sp-name">{point.name}</div>
                      <div className="location-sp-address">{point.address}</div>
                    </div>
                    <div className="location-sp-locate-btn">
                      <Button
                        type="button"
                        disabled={!point.location}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleServicePointSelection(point);
                        }}
                      >
                        Select
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mapCenter}
              zoom={mapZoom}
            >
              {servicePointsData
                ?.filter((p: any) => p.location)
                ?.map((point: any) => (
                  <Marker
                    key={point.id}
                    position={point.location}
                    onClick={() => setSelected(point)}
                    icon={customMarkerIcon}
                  />
                ))}
              {selected?.location && (
                <div className="map-pin-wrapper">
                  <InfoWindow
                    position={selected.location}
                    onCloseClick={() => setSelected(null)}
                  >
                    <div className="map-location-tooltip">
                      <div className="selected-service-point-name">
                        {selected?.name}
                      </div>
                      <div className="selected-service-point-address">
                        {selected?.address ?? "Address Not Available"}
                      </div>
                      <div className="selected-service-point-goto-location-wrapper">
                        <div
                          className="selected-service-point-goto-location"
                          onClick={() =>
                            getDirectionFunc(
                              selected?.location.lat,
                              selected?.location.lng,
                            )
                          }
                        >
                          Go To Location
                        </div>
                      </div>
                    </div>
                  </InfoWindow>
                </div>
              )}
            </GoogleMap>
          </div>
        </div>
      </LoadScript>
    </div>
  );
};

export default StoreLocator;
